import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { numberFormat } from 'helper';
import moment from 'moment';
import PropTypes from 'prop-types';
import TransactionRow from 'modules/common/components/TransactionRow';
import _ from 'lodash';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import SupersededAssessmentModal from '../modals/SupersededAssessmentModal';

function SupersededAssessmentContainer({
  getSingleRecordOfSupAssessment,
  dataInfo,
  getRecordOfSupAssessmentList,
  getHistoryRecordofSupAssessmentList,
  applicationId,
  applicationType,
  applicationStatus,
  historyApplicationId,
  removeRecordOfSupAssessment,
  dataList,
  type,
  isLoading,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    if (!_.isEmpty(_.get(dataList, '0.id'))) {
      const id = _.get(dataList, '0.id');
      if (type !== 'history')
        getSingleRecordOfSupAssessment(applicationId, id);
    }
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history')
      getHistoryRecordofSupAssessmentList(historyApplicationId);
    else getRecordOfSupAssessmentList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history')
      getHistoryRecordofSupAssessmentList(historyApplicationId);
    else getRecordOfSupAssessmentList(applicationId);
  }, [applicationId]);

  useEffect(() => {
    if (dataList.length > 0) {
      OnSetFormData();
    }
  }, [dataList]);

  useEffect(() => {
    if (dataList.length > 0) {
      OnSetFormData();
    }
  }, []);

  const handleAddLandRecordofSupAssessment = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <SupersededAssessmentModal
          applicationId={applicationId}
          type="NEW"
        />
      ),
      title: 'Add Land Record of Superseded Assessment',
      modalSize: 'modal-md',
    });
  };

  const handleOnUpdate = (id, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <SupersededAssessmentModal
          updateList={data.attributes}
          id={data.id}
          applicationId={id}
          type="EDIT"
        />
      ),
      title: 'Update Land Record of Superseded Assessment',
      modalSize: 'modal-md',
    });
  };

  const handleOnRemove = (id, data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this Land Record of Superseded Assessment?',
      () => {
        removeRecordOfSupAssessment(id, data, () => {
          getRecordOfSupAssessmentList(id);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <>
      <div className="row p-3">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            {(type !== 'history' && applicationType !== 5 &&
              applicationStatus !== 'CANCELLED' && (
                <div className="col-12 d-flex">
                  <div className="ml-auto">
                    <button
                      onClick={handleAddLandRecordofSupAssessment}
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  mb-2"
                    >
                      Add Record of Superseded Assessment
                    </button>
                  </div>
                </div>
              ))}
            {dataList.map((item) => {
              return (
                <React.Fragment key={item.id}>
                  {(type !== 'history' && applicationType !== 5 &&
                    applicationStatus !== 'CANCELLED' && (
                      <div className="col-12 text-right">
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleOnUpdate(
                            applicationId,
                            dataInfo
                          )}
                        >
                          <i className="far fa-edit icon-edit" />
                        </button>
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleOnRemove(
                            applicationId,
                            dataInfo.id
                          )}
                        >
                          <i className="far fa-trash-alt icon-delete" />
                        </button>
                      </div>
                    ))}
                  <div className="col-12 mt-3">
                    <table className="transaction-table table table-borderless table-sm table-striped">
                      <tbody>
                        <TransactionRow
                          title="PIN"
                          value={_.get(item, 'attributes.pin') || '--'}
                        />
                        <TransactionRow
                          title="TDN No."
                          value={_.get(item, 'attributes.td_no') || '--'}
                        />
                        <TransactionRow
                          title="Previous Owner"
                          value={_.get(item, 'attributes.previous_owner') ||
                            '--'}
                        />
                        <TransactionRow
                          title="AR Page No."
                          value={_.get(item, 'attributes.ar_page_no') || '--'}
                        />
                        <TransactionRow
                          title="ARP No."
                          value={_.get(item, 'attributes.arp_no') || '--'}
                        />
                        <TransactionRow
                          title="Total Assessed Value"
                          value={numberFormat(
                            _.get(
                              item,
                              'attributes.total_assessed_value'
                            ),
                            2
                          ) || '--'}
                        />
                        <TransactionRow
                          title="Effectivity of Assessment"
                          value={_.get(item,
                            'attributes.effectivity_of_assessment')
                            ? moment(
                              `${_.get(
                                item,
                                'attributes.effectivity_of_assessment'
                              )}`
                            ).format('YYYY')
                            : '--'}
                        />
                      </tbody>
                    </table>
                  </div>
                  <hr className='below-table' style={{ marginTop: 10, marginLeft: 250 }} />
                  <div className="col-12 mt-3">
                    <table className="transaction-table table table-borderless table-sm table-striped">
                      <tbody>
                        <TransactionRow
                          title="Recording Person"
                          value={_.get(item, 'attributes.recording_person') ||
                            '--'}
                        />
                        <TransactionRow
                          title="Date"
                          value={_.get(item, 'attributes.date')
                            ? moment(
                              `${_.get(
                                item, 'attributes.date'
                              )}`
                            ).format('MM/DD/YYYY HH:mm a')
                            : '--'}
                        />
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>
              );
            })}
          </>
        )}
      </div>
    </>
  );
}
SupersededAssessmentContainer.defaultProps = {
  type: '',
  applicationId: '',
  applicationType: 0,
  applicationStatus: '',
  historyApplicationId: '',
};

SupersededAssessmentContainer.propTypes = {
  getSingleRecordOfSupAssessment: PropTypes.instanceOf(Function).isRequired,
  getRecordOfSupAssessmentList: PropTypes.instanceOf(Function).isRequired,
  getHistoryRecordofSupAssessmentList:
    PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  applicationType: PropTypes.number,
  applicationStatus: PropTypes.string,
  historyApplicationId: PropTypes.string,
  removeRecordOfSupAssessment: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_RECORD_OF_SUP_ASSESSMENT}.list`) || [],
  dataInfo:
    _.get(api, `${c.GET_SINGLE_RECORD_OF_SUP_ASSESSMENT}.item`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_RECORD_OF_SUP_ASSESSMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SupersededAssessmentContainer);
